/* eslint-disable aveny/no-color-rule */

import Box from '@mui/material/Box';
import { RapportKontroll } from './RapportKontroll';
import { A4Width, A4Height, UpdateControlFunction } from './RapportMall';
import {
  AVENY_REPORT_DEFAULT_BAND_HEIGHT,
  AVENY_REPORT_TITLE_FONT_SIZE,
  AVENY_REPORT_TITLE_HEIGHT,
} from './RapportMallUtils';
import RapportTypography from './RapportTypography';

interface IRapportPageProps {
  controls: any[];
  onSelect: (path: number[]) => void;
  onUpdate: UpdateControlFunction;
  pageIndex: number;
  pageTitle?: string;
  pageTitleLeft?: number;
  scale: number;
  startIndex: number;
  selectedPath?: number[];
  pageMarginLeft: number;
  pageMarginTop: number;
  pageMarginRight: number;
  pageMarginBottom: number;
  showDottedBorders: boolean;
}

export const RapportPage: React.FC<IRapportPageProps> = ({
  controls,
  onSelect,
  onUpdate,
  pageIndex,
  pageTitle,
  pageTitleLeft,
  scale,
  startIndex,
  selectedPath,
  pageMarginLeft,
  pageMarginTop,
  pageMarginRight,
  pageMarginBottom,
  showDottedBorders,
}) => (
  <Box
    sx={{
      flex: '0 0 auto',
      width: A4Width * scale,
      height: A4Height * scale,
      paddingTop: `${pageMarginTop * scale}px`,
      paddingLeft: `${pageMarginLeft * scale}px`,
      paddingRight: `${pageMarginRight * scale}px`,
      paddingBottom: `${pageMarginBottom * scale}px`,
      background: '#fff',
      boxShadow: '0 0 8px #bbb',
      boxSizing: 'border-box',
      marginTop: 0,
      marginBottom: 2,
      marginRight: 0,
      marginLeft: 0,
      position: 'relative',
      overflow: 'clip',
    }}
  >
    <Box
      sx={{
        position: 'relative',
        overflow: 'visible',
        width: '100%',
        height: '100%',
        border: '1px solid #ddd',
      }}
    >
      {pageIndex === 0 && (
        <Box
          sx={{
            position: 'relative',
            overflow: 'visible',
            width: '100%',
            height: `${AVENY_REPORT_TITLE_HEIGHT * scale}px`,
            color: '#888',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: pageTitleLeft
                ? `${(pageTitleLeft - 10) * scale}px`
                : '45%',
              height: '75%',
              border: '1px solid #ddd',
              padding: '4px 8px',
              boxSizing: 'border-box',
            }}
          >
            <RapportTypography>{'Logo'}</RapportTypography>
          </Box>

          <Box
            sx={{
              position: 'absolute',
              left: pageTitleLeft ? `${pageTitleLeft * scale}px` : '50%',
            }}
          >
            <RapportTypography Style={'b'} Size={AVENY_REPORT_TITLE_FONT_SIZE}>
              {pageTitle}
            </RapportTypography>
          </Box>
        </Box>
      )}

      {controls.map((ctrl, i) => (
        <RapportKontroll
          ctrl={ctrl}
          idx={i}
          key={i}
          maxWidth={A4Width - pageMarginLeft - pageMarginRight}
          defaultHeight={AVENY_REPORT_DEFAULT_BAND_HEIGHT}
          onSelect={onSelect}
          onUpdate={onUpdate}
          controlPath={[startIndex + i]}
          selectedPath={selectedPath}
          pageMarginLeft={pageMarginLeft}
          pageMarginTop={pageMarginTop}
          pageMarginRight={pageMarginRight}
          pageMarginBottom={pageMarginBottom}
          showDottedBorders={showDottedBorders}
        />
      ))}
    </Box>
  </Box>
);
